import { useEffect, useState } from 'react';
import * as Y from 'yjs';
import { HocuspocusProvider } from '@hocuspocus/provider';

interface SyncState {
  doc: Y.Doc | null;
  provider: HocuspocusProvider | null;
  synced: boolean;
}

export function useEhxcelSync(documentId: string, userToken: string, shouldConnect: boolean = true): SyncState {
  const [syncState, setSyncState] = useState<SyncState>({
    doc: null,
    provider: null,
    synced: false,
  });

  useEffect(() => {
    if (!shouldConnect) return;

    const ydoc = new Y.Doc();

    const provider = new HocuspocusProvider({
      url: import.meta.env.VITE_WS_URL || 'wss://api.cellysheets.ca',
      name: documentId,
      document: ydoc,
      token: userToken, 
      
      onConnect: () => console.log(`Connected to CellySheet Doc: ${documentId}`),
      onSynced: () => {
        console.log('Initial state loaded from Postgres/Server!');
        setSyncState((prev) => ({ ...prev, synced: true }));
      },
      onClose: () => console.log('Disconnected from server'),
    });

    setSyncState({
      doc: ydoc,
      provider,
      synced: false,
    });

    return () => {
      provider.destroy();
      ydoc.destroy();
    };
  }, [documentId, userToken, shouldConnect]);

  return syncState;
}